{
  "familyId": "MET-OPP-DRIEHOEK",
  "questions": [
    {
      "id": "MET-OPP-DRIEHOEK-001",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een driehoekig raam met een basis van 10 cm en een hoogte van 6 cm. Wat is de oppervlakte?",
      "options": ["30 cm²", "60 cm²", "16 cm²", "36 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 10,
            "height": 6,
            "showGrid": true,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte driehoek",
            "content": "Oppervlakte driehoek = (basis × hoogte) ÷ 2. Een driehoek is de helft van een rechthoek! Dus: (10 × 6) ÷ 2 = 60 ÷ 2 = 30 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_base_height",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De architect gebruikt de formule: oppervlakte driehoek = (basis × hoogte) ÷ 2. Dus: (10 × 6) ÷ 2 = 60 ÷ 2 = 30 cm². Waarom delen door 2? Omdat een driehoek altijd de helft is van een rechthoek met dezelfde basis en hoogte. Check: een rechthoek van 10 × 6 = 60 cm², de helft = 30 cm² ✓.",
        "solutionSteps": [
          "Formule: oppervlakte driehoek = (basis × hoogte) ÷ 2",
          "Invullen: (10 × 6) ÷ 2",
          "Uitrekenen: 60 ÷ 2 = 30 cm²",
          "Check: een rechthoek van 10 × 6 = 60 cm², de helft = 30 cm² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! (10 × 6) ÷ 2 = 30 cm².",
          "1": "Je dacht waarschijnlijk dat je basis × hoogte doet zonder te delen. Maar een driehoek is de helft van een rechthoek, dus je deelt altijd door 2: (10 × 6) ÷ 2 = 30 cm². Onthoud: driehoek = rechthoek ÷ 2.",
          "2": "Je dacht waarschijnlijk dat je basis + hoogte doet (10 + 6 = 16). Maar voor oppervlakte vermenigvuldig je en deel je door 2: (10 × 6) ÷ 2 = 30 cm². Onthoud: oppervlakte = vermenigvuldigen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je 6 × 6 doet. Maar je gebruikt de basis (10 cm) én de hoogte (6 cm): (10 × 6) ÷ 2 = 30 cm². Onthoud: gebruik altijd basis én hoogte."
        }
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-002",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Een timmerman zaagt een driehoekig stuk hout met een basis van 8 cm en een hoogte van 5 cm. Wat is de oppervlakte?",
      "options": ["20 cm²", "40 cm²", "13 cm²", "26 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 8,
            "height": 5,
            "showGrid": true,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte driehoek",
            "content": "Oppervlakte = (basis × hoogte) ÷ 2 = (8 × 5) ÷ 2 = 40 ÷ 2 = 20 cm². Vergeet niet te delen door 2!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_basic",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De timmerman berekent: oppervlakte driehoek = (basis × hoogte) ÷ 2. Vul de maten in: (8 × 5) ÷ 2 = 40 ÷ 2 = 20 cm². Waarom delen door 2? Een driehoek is altijd de helft van een rechthoek met dezelfde basis en hoogte. Check: rechthoek 8 × 5 = 40 cm², helft = 20 cm² ✓.",
        "solutionSteps": [
          "Formule: (basis × hoogte) ÷ 2",
          "Invullen: (8 × 5) ÷ 2",
          "Uitrekenen: 40 ÷ 2 = 20 cm²",
          "Check: rechthoek 8 × 5 = 40 cm², helft = 20 cm² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! (8 × 5) ÷ 2 = 20 cm².",
          "1": "Je dacht waarschijnlijk dat je niet door 2 hoeft te delen. Maar een driehoek is de helft van een rechthoek: (8 × 5) ÷ 2 = 20 cm², niet 40 cm². Onthoud: driehoek = altijd ÷ 2.",
          "2": "Je dacht waarschijnlijk dat je basis + hoogte doet (8 + 5 = 13). Maar voor oppervlakte vermenigvuldig je: (8 × 5) ÷ 2 = 20 cm². Onthoud: oppervlakte = vermenigvuldigen.",
          "3": "Je dacht waarschijnlijk dat je de omtrek berekent of verkeerd vermenigvuldigt. De oppervlakte is (8 × 5) ÷ 2 = 20 cm². Onthoud: gebruik de formule (basis × hoogte) ÷ 2."
        }
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-003",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Een tuinontwerper weet dat een driehoekig bloembed 24 cm² is. De basis is 8 cm. Wat is de hoogte?",
      "options": ["6 cm", "3 cm", "16 cm", "12 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 8,
            "height": 6,
            "hideHeight": true,
            "showGrid": true,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogte berekenen",
            "content": "Oppervlakte = (basis × hoogte) ÷ 2. Dus: 24 = (8 × hoogte) ÷ 2. Vermenigvuldig met 2: 48 = 8 × hoogte. Deel door 8: hoogte = 6 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_reverse",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De tuinontwerper rekent terug: oppervlakte = (basis × hoogte) ÷ 2. Dus: 24 = (8 × hoogte) ÷ 2. Eerst ×2: 48 = 8 × hoogte. Dan ÷8: hoogte = 6 cm. Check: (8 × 6) ÷ 2 = 24 ✓.",
        "solutionSteps": [
          "Formule: oppervlakte = (basis × hoogte) ÷ 2",
          "Invullen: 24 = (8 × hoogte) ÷ 2",
          "Vermenigvuldig met 2: 24 × 2 = 48",
          "Deel door de basis: 48 ÷ 8 = 6 cm",
          "Check: (8 × 6) ÷ 2 = 24 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Hoogte = (24 × 2) ÷ 8 = 48 ÷ 8 = 6 cm.",
          "1": "Je dacht waarschijnlijk dat je 24 ÷ 8 doet (= 3). Maar je moet eerst ×2 doen omdat de formule ÷2 bevat: (24 × 2) ÷ 8 = 6 cm. Onthoud: draai de ÷2 om naar ×2.",
          "2": "Je dacht waarschijnlijk dat je 24 × 2 ÷ 3 doet. Maar je deelt door de basis (8), niet door 3: (24 × 2) ÷ 8 = 6 cm. Onthoud: deel door de basis.",
          "3": "Je dacht waarschijnlijk dat je 24 × 2 ÷ 4 doet. Maar je deelt door de basis (8): (24 × 2) ÷ 8 = 6 cm. Onthoud: deel door de basis."
        }
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-004",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Een zeilmaker maakt een driehoekig zeil met een basis van 3 meter en een hoogte van 4 meter. Hoeveel vierkante meter stof is er nodig?",
      "options": ["6 m²", "12 m²", "7 m²", "24 m²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 3,
            "height": 4,
            "showGrid": false,
            "unit": "m"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte driehoek in context",
            "content": "Het zeil is driehoekig, dus: oppervlakte = (basis × hoogte) ÷ 2 = (3 × 4) ÷ 2 = 12 ÷ 2 = 6 m².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_context",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De zeilmaker berekent: het zeil is driehoekig, dus oppervlakte = (basis × hoogte) ÷ 2 = (3 × 4) ÷ 2 = 12 ÷ 2 = 6 m². Er is 6 m² stof nodig. Check: een rechthoek van 3 × 4 = 12 m², de helft = 6 m² ✓.",
        "solutionSteps": [
          "Het zeil is driehoekig → formule: (basis × hoogte) ÷ 2",
          "Invullen: (3 × 4) ÷ 2",
          "Uitrekenen: 12 ÷ 2 = 6 m²",
          "Check: rechthoek 3 × 4 = 12 m², helft = 6 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! (3 × 4) ÷ 2 = 6 m².",
          "1": "Je dacht waarschijnlijk dat je niet door 2 hoeft te delen. Maar het zeil is driehoekig, niet rechthoekig: (3 × 4) ÷ 2 = 6 m². Onthoud: driehoek = altijd ÷ 2.",
          "2": "Je dacht waarschijnlijk dat je basis + hoogte doet (3 + 4 = 7). Maar voor oppervlakte vermenigvuldig je en deel je door 2: (3 × 4) ÷ 2 = 6 m². Onthoud: oppervlakte = vermenigvuldigen.",
          "3": "Je dacht waarschijnlijk dat je ×2 doet in plaats van ÷2. Maar bij een driehoek deel je door 2: (3 × 4) ÷ 2 = 6 m², niet 3 × 4 × 2 = 24 m². Onthoud: driehoek = ÷ 2."
        }
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-005",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Een tekenaar zoekt de driehoek met een oppervlakte van 15 cm². Welke is het?",
      "options": ["basis 6 cm, hoogte 5 cm", "basis 5 cm, hoogte 5 cm", "basis 10 cm, hoogte 2 cm", "basis 3 cm, hoogte 8 cm"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlaktes vergelijken",
            "content": "Bereken elke oppervlakte met (basis × hoogte) ÷ 2: (6×5)÷2=15 ✓, (5×5)÷2=12,5, (10×2)÷2=10, (3×8)÷2=12. Alleen de eerste geeft 15 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_identify",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De tekenaar berekent elke oppervlakte met (basis × hoogte) ÷ 2: (6×5)÷2 = 15 cm² ✓, (5×5)÷2 = 12,5 cm², (10×2)÷2 = 10 cm², (3×8)÷2 = 12 cm². Alleen de eerste driehoek heeft 15 cm². Tip: reken alle opties na om zeker te zijn.",
        "solutionSteps": [
          "Bereken elke optie: (basis × hoogte) ÷ 2",
          "A: (6 × 5) ÷ 2 = 15 cm² ✓",
          "B: (5 × 5) ÷ 2 = 12,5 cm² ✗",
          "C: (10 × 2) ÷ 2 = 10 cm² ✗",
          "D: (3 × 8) ÷ 2 = 12 cm² ✗"
        ],
        "distractorExplanations": {
          "0": "Goed! (6 × 5) ÷ 2 = 30 ÷ 2 = 15 cm².",
          "1": "Je dacht waarschijnlijk dat (5 × 5) ÷ 2 = 15. Maar (5 × 5) ÷ 2 = 12,5 cm², niet 15. Onthoud: reken altijd na.",
          "2": "Je dacht waarschijnlijk dat (10 × 2) ÷ 2 = 15. Maar (10 × 2) ÷ 2 = 10 cm², niet 15. Onthoud: reken altijd na.",
          "3": "Je dacht waarschijnlijk dat (3 × 8) ÷ 2 = 15. Maar (3 × 8) ÷ 2 = 12 cm², niet 15. Onthoud: reken altijd na."
        }
      }
    }
  ]
}